import {
  MeetingStartTimes,
  isUsersCombinedMeetingStartTimes,
} from '../../load-availability-options'

export const getAvailableAssigneesForSlot = ({
  slot,
  timeSlots,
}: {
  slot: string
  timeSlots?: MeetingStartTimes | null
}) => {
  if (!timeSlots) {
    return { userIds: [], availableRoundRobinAssignees: [] }
  }

  if (isUsersCombinedMeetingStartTimes(timeSlots)) {
    return { userIds: timeSlots.userIds, availableRoundRobinAssignees: [] }
  }

  const filteredMultiRoundRobinSlots =
    timeSlots.startTimes?.filter(item => 'availableAttendees' in item) ?? []

  const startTime = filteredMultiRoundRobinSlots?.find(timeSlot => timeSlot.startTime === slot)

  if (startTime) {
    return { userIds: [], availableRoundRobinAssignees: startTime.availableAttendees }
  }

  return { userIds: [], availableRoundRobinAssignees: [] }
}
